/* 
  Gets JSON files from the Data Requests bucket
  < input = S3 >
 < output = s3Data filtered based on filename tag in the JSON files.
 Filename tag must match the current selected Snapshot to be displayed. > 
*/

export async function getAllDataRequests(S3) {
  // S3 bucket and prefix
  const bucket = process.env.REACT_APP_S3_DATAREQUESTS_BUCKET;
  const companyName = localStorage.getItem("company");
  const currentSnapshot = localStorage.getItem("selectedSnapshot");
  const prefix = `${companyName}/public`;

  try {
    // Fetch objects in bucket with prefix
    const s3Response = await S3.listObjectsV2({
      Bucket: bucket,
      Prefix: prefix,
    }).promise();

    // Process S3 objects and the tags assigned to them
    const dataPromises = s3Response.Contents.filter(
      (item) => !item.Key.endsWith("/") && item.Key.endsWith(".json")
    ).map(async (item) => {
      //Get the Tags assigned to each file
      const taggingResponse = await S3.getObjectTagging({
        Bucket: bucket,
        Key: item.Key,
      }).promise();

      //Filename Tag - needed filter the files and to delete the file
      const filenameTag = taggingResponse.TagSet.find(
        (tag) => tag.Key === "Filename"
      );
      const filename = filenameTag ? filenameTag.Value : "";

      //Check if the filenameTag matches the selectedSnapshot and filter snapshots
      if (filename && filename === currentSnapshot) {
        const objectData = await S3.getObject({
          Bucket: bucket,
          Key: item.Key,
        }).promise();

        //Remaining Tags

        //Member Name Tag
        const memberNameTag = taggingResponse.TagSet.find(
          (tag) => tag.Key === "MemberName"
        );
        const memberName = memberNameTag ? memberNameTag.Value : "";

        //Phone Tag
        const phoneTag = taggingResponse.TagSet.find(
          (tag) => tag.Key === "Phone"
        );
        const phone = phoneTag ? phoneTag.Value : "";

        //AssignedProperties Tag (properties are separated by spaces as commas are not allowed on Tags in S3)
        const assignedPropertiesTag = taggingResponse.TagSet.find(
          (tag) => tag.Key === "AssignedProperties"
        );
        const assignedProperties = assignedPropertiesTag
          ? assignedPropertiesTag.Value.replace(/ /g, ", ")
          : "";

        //RequestFormLink
        const requestFormLinkTag = taggingResponse.TagSet.find(
          (tag) => tag.Key === "RequestFormLink"
        );
        const requestFormLink = requestFormLinkTag
          ? requestFormLinkTag.Value
          : "";

        //Form Status Tag
        const statusTag = taggingResponse.TagSet.find(
          (tag) => tag.Key === "Status"
        );
        const status = statusTag ? statusTag.Value : "";

        return {
          date: item.LastModified.toLocaleString(),
          MemberName: memberName,
          Phone: phone,
          AssignedProperties: assignedProperties,
          requestformlink: requestFormLink,
          status: status,
          filename: filename,
        };
      }
      return undefined; //if the filename does not match the selected snapshot
    });

    const data = await Promise.all(dataPromises);
    //Filter out objects that do not match the currentSnapshot
    const filteredData = data.filter((item) => item !== undefined);
    return filteredData;
  } catch (error) {
    console.error("Error fetching data from S3:", error);
    return [];
  }
}
